// Password rules shared by every screen where a new password is chosen.
//
// The server is the authority: it also rejects commonly used passwords and ones that
// contain the part of the account's email before the @. The client only checks what
// it can check cheaply (length, a letter, a number) so the person gets the message
// beside the field instead of after a round trip. Kept identical across the portals.

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 128;

export const PASSWORD_RULES_TEXT =
  '8 to 128 characters, with at least one letter and one number. '
  + 'Common passwords, and ones containing the part of the email before the @, are not accepted.';

/** Returns a message describing what's wrong with `password`, or '' if it passes the client-side checks. */
export function passwordProblem(password) {
  const pw = password || '';
  if (pw.length < PASSWORD_MIN_LENGTH) return `Password must be at least ${PASSWORD_MIN_LENGTH} characters.`;
  if (pw.length > PASSWORD_MAX_LENGTH) return `Password must be at most ${PASSWORD_MAX_LENGTH} characters.`;
  if (!/[A-Za-z]/.test(pw)) return 'Password must include at least one letter.';
  if (!/[0-9]/.test(pw)) return 'Password must include at least one number.';
  return '';
}

/**
 * Readable message from an API error. FastAPI returns `detail` as a string for
 * HTTPException, or as an array of {msg, loc} objects for pydantic 422s — never hand
 * the array itself to a toast/Alert (React can't render plain objects).
 */
export function apiErrorMessage(err, fallback = 'Request failed') {
  const d = err?.response?.data?.detail;
  if (typeof d === 'string' && d) return d;
  if (Array.isArray(d) && d.length) {
    return d
      .map((x) => (typeof x === 'string' ? x : String(x?.msg || '').replace(/^Value error,\s*/i, '')))
      .filter(Boolean)
      .join(' ') || fallback;
  }
  return fallback;
}
